import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../../environments/environment';

import { NotificationService } from '../notifications/notification.service';

/** Application-wide error handler that adds a UI notification to the error handling
 * provided by the default Angular ErrorHandler.
 */
@Injectable()
export class AppErrorHandler extends ErrorHandler {
  constructor(private notificationsService: NotificationService) {
    super();
  }

  handleError(error: HttpErrorResponse) {
    let displayMessage = 'Ocurrió un error.';

    if (error.error.errors && error.error.errors.length > 0) {
      displayMessage = error.error.errors[0].detail;
    } else if (!environment.production) {
      displayMessage += ' Ver consola para más detalles.';
    }

    this.notificationsService.error(displayMessage);
    super.handleError(error);
  }
}
